import riot from 'riot';
export default riot.observable(new (function() {})());
